// extracted by mini-css-extract-plugin
export var logo = "newHeader-module--logo--2XRPL";